import React from 'react';
import './Hero.css';

const Hero=()=> {
  return (
    <section id="home" className="hero">
      <div className="hero-container">
        <div className="hero-content">
          <div className="hero-text">
            <h1 className="hero-title fade-in-up">
              Real Conversations.<br />
              Real Stories.<br />
              Real Point Makers.
            </h1>
            <p className="hero-subtitle fade-in-up fade-in-delay-1">
              Hosted by brothers Darrence & Demetrius Davis — conversations that enlighten,engage,entertain,and educate.
            </p>
            <div className="hero-buttons fade-in-up fade-in-delay-2">
              <a href="https://youtube.com/@pointmakerspodcast?si=khoIm_WB-cYQAAql" className="btn-primary" target="_blank" rel="noopener noreferrer">
                Watch on YouTube →
              </a>
              <a href="#guest" className="btn-outline">
                Be a Guest →
              </a>
            </div>
            <p className="hero-proof fade-in-up fade-in-delay-3">
              Never the ones to be 'Chatty Patty,' we focus on conversation that matters.
            </p>
          </div>
          <div className="hero-video fade-in-up fade-in-delay-2">
            <div className="cinematic-frame">
              <div className="frame-lights">
                <div className="frame-light"></div>
                <div className="frame-light"></div>
                <div className="frame-light"></div>
              </div>
              <div className="frame-inner">
                <div className="video-wrapper">
                  <iframe 
                    src="https://www.youtube.com/embed/xPBRTZNuemc?si=tNRfNSBfx9bkQN4G&autoplay=1&mute=1&loop=1&playlist=xPBRTZNuemc" 
                    title="Point Makers Podcast - Professional studio conversation with hosts Darrence and Demetrius Davis"
                    frameBorder="0" 
                    allow="accelerometer;autoplay;clipboard-write;encrypted-media;gyroscope;picture-in-picture;web-share"
                    allowFullScreen 
                    className="video-embed" 
                    referrerPolicy="strict-origin-when-cross-origin"
                    loading="lazy"
                  />
                </div>
              </div>
            </div>
            <p className="hero-video-caption fade-in-up fade-in-delay-3">
              Legendary interviews happen here.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;